import { createStyles, makeStyles } from '@material-ui/core';
var useStyles = makeStyles(function (theme) {
    var _a;
    return createStyles({
        progreso: (_a = {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginLeft: '1.25rem'
            },
            _a[theme.breakpoints.down('sm')] = {
                marginTop: '3.25rem',
                maxWidth: '336px',
                margin: '0',
            },
            _a),
        contador: {
            position: 'absolute',
        },
    });
});
export default useStyles;
